module.exports = __webpack_public_path__ + "assets/img/yellow-arrow-right.a28708ea.png";